export var defaultProps = {
  className: '',
  size: 'default',
  style: {},
  type: 'default'
};